import { Components, Theme } from '@mui/material/styles';

import { getPrimaryButtonStyles, getSecondaryButtonStyles } from './buttonStyles';

export default function MuiLink(theme: Theme): Components['MuiLink'] {
  return {
    styleOverrides: {
      root: {
        color: 'inherit',
        textDecoration: 'inherit',
        backgroundImage: `linear-gradient(to right in oklab, ${theme.palette.desert.main} 0px, ${theme.palette.desert.main} 100%)`,
        transitionProperty: 'background-size',
        transitionDuration: '50ms',
        transitionTimingFunction: 'cubic-bezier(.4,0,.2,1)',
        backgroundPosition: '0 100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% .1rem',
        '&:hover': {
          backgroundSize: '100% .2rem',
        },
        '&[role="button"]': {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
          position: 'relative',
          whiteSpace: 'nowrap',
          color: theme.palette.taiga.main,
          fontWeight: 900,
          transition: 'all .5s ease-in-out',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          borderRadius: 9999,
          textDecoration: 'none',
          backgroundImage: 'none',
          backgroundSize: 'unset',
          fontSize: '14px',
          lineHeight: '16px',
          padding: '7px 16px 8px 16px',
          maxHeight: '35px',
          cursor: 'pointer',
          ...getSecondaryButtonStyles(theme),
          '&[role="button"][data-size="compact"]': {
            fontSize: '12px',
            lineHeight: '14px',
            padding: '4px 12px',
            maxHeight: '28px',
          },
        },
        '&[role="button"][data-button-variant="primary"]': {
          ...getSecondaryButtonStyles(theme),
          ...getPrimaryButtonStyles(theme),
          '&[data-size="compact"]': {
            fontSize: '12px',
            lineHeight: '14px',
            padding: '4px 12px',
            maxHeight: '28px',
          },
        },
      },
    },
  };
}
